import axios from '../axios/axios';
import {
  PY_DATA_REQUEST,
  PY_DATA_SUCCESS,
  PY_DATA_FAIL,
} from '../constants/physicianInformationConstants';

export const physicianInfomationAction = () => async (dispatch) => {
  try {
    dispatch({ type: PY_DATA_REQUEST });
    const { data } = await axios.post('/rpiq-form-fetch', {
      section: 'f1v1s6',
      form_id: localStorage.getItem('formId'),
    });

    dispatch({
      type: PY_DATA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (
      error?.response?.status === 401 ||
      error?.response?.detail === 'Not authenticated'
    ) {
      window.location.replace('/');
    }
    dispatch({
      type: PY_DATA_FAIL,
      payload: error,
    });
  }
};
